import { useDriverForm } from '@/modules/drivers/context/DriverFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DateField } from '@/ui/form/controls/DateField'
import { TextField } from '@/ui/form/controls/TextField'
import * as React from 'react'

const CardsStage = () => {
  const { t } = useLocalize()
  const { data, setData } = useDriverForm()
  return (
    <div className="tw-flex tw-justify-between">
     <div className="tw-w-full tw-max-w-[256px]">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          {t('driverBasics.cards')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label={t('driverBasics.card-number')}
          required
          placeholder={t('common.type')}
          value={data?.driverCard?.cardNumber?.value || ''}
          onChange={(e) =>
            setData({
              ...data,
              driverCard: {
                ...data?.driverCard,
                cardNumber: {
                  ...data?.driverCard?.cardNumber,
                  value: e.target.value,
                },
              },
            })
          }
        />
        {/* @TODO */}
        {/* <DateField
          label={t('driverBasics.card-valid-from')}
          value={data?.cardValidFrom}
          setValue={(e) =>
            setData({ ...data, workingStartTime: e })
          }
        /> */}

        <DateField
          label={t('driverBasics.card-valid-to')}
          value={data?.driverCard?.cardValidTo || ''}
          setValue={(e) =>
            setData({
              ...data,
              driverCard: {
                ...data?.driverCard,
                cardValidTo: e,
              },
            })
          }
        />
      </div>
    </div>
  )
}

export default CardsStage
